import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { disabled: boolean }>(
  {
    label: {
      display: 'inline-block',
      cursor: 'pointer',
    },
    labelDisabled: {
      display: 'inline-block',
      cursor: 'not-allowed',
    },
    fab: {
      cursor: 'pointer',
    },
    icon: {
      display: 'inline-block',

      '& > svg > path': {
        fill: 'currentColor',
      },
    },
    control: {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      borderWidth: 0,
    },
  },
  {
    name: 'upload-button',
  },
);

export default useStyles;
